import Row from "@amzn/meridian/row";
import {
  setInputText,
  setShowResult,
} from "src/components/pages/home/store/chatSlice";
import {
  ERGONA_QUESTIONS,
  POLICY_QUESTIONS,
  SAIGE_METRICS_QUESTIONS,
} from "src/constants/constants";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { getCurrentRegion } from "src/utils/regionUtils";
import "./chatCards.scss";
import OutlinedButton from "src/components/shared/outlinedButton/outlinedButton";

const ChatCards = ({ inputRef, isOnMcpRoute }) => {
  const dispatch = useAppDispatch();
  const { isAdministrator } = useAppSelector((state) => state.user);
  const fillInput = (prompt: string) => {
    dispatch(setShowResult(false));
    dispatch(setInputText(prompt));
    inputRef.current.focus();
  };

  return (
    <div className="chat-cards">
      {isOnMcpRoute ? (
        <Row alignmentHorizontal="center" wrap="down" spacing={"300"}>
          {(isAdministrator
            ? SAIGE_METRICS_QUESTIONS()
            : ERGONA_QUESTIONS()
          ).map((question) => (
            <OutlinedButton key={question} onClick={() => fillInput(question)}>
              {question}
            </OutlinedButton>
          ))}
        </Row>
      ) : (
        <Row
          alignmentHorizontal="center"
          wrap="down"
          spacing={"300"}
          width={712}
          spacingInset={"200 400"}
        >
          {POLICY_QUESTIONS(getCurrentRegion()).map((question) => (
            <OutlinedButton key={question} onClick={() => fillInput(question)}>
              {question}
            </OutlinedButton>
          ))}
        </Row>
      )}
    </div>
  );
};

export default ChatCards;
